<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('select_form') }}
      //- v-card-title.px-5.primary
        v-row(no-gutters)
          v-col
            p.mb-0.title.white--text Select form
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="white" :size="24") mdi-close

      v-card-text.pa-0.text-center
        div.container
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-form(v-else ref="form")
            v-layout.my-6(v-if="forms.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('forms_not_found') }}
            v-card(v-else outlined)
              v-list.pa-0
                div(v-for='(form, index) in forms')
                  v-divider(v-if="index != 0")
                  v-list-item(:key='form.id' @click="selectedFormSlug = form.slug")
                    v-col.px-0.text-left
                      div.p1.basic800--text {{ form.name }}
                      div.c1.basic600--text {{ $t('products') }}: {{ form.products.length }}
                      div.c1.basic600--text {{ $t('clicks') }}: {{ form.total_clicks }}
                      div.c2.basic600--text {{ $t('sales') }}: {{ form.total_sales | displayPrice }}
                    v-list-item-action(v-show="selectedFormSlug == form.slug")
                      v-btn(icon)
                        v-icon(color='success') mdi-check

          y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="totalCount")

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='clickShare' :disabled="!selectedFormSlug")
          .button-AA-small.basic100--text {{ $t('share') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RepeatOrderDialog',
  props: ['open', 'lead'],
  data: () => ({
    isFetching: true,
    selectedFormSlug: null,
    forms: [],
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    totalCount: 0
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchForms(val)
      }
    }
  },
  mounted () {
    this.$axios.get(`/leads/${this.lead.pid}/`)
      .then((response) => {
        this.lead = response.data
        this.fetchForms(1)
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.lead.company}&ordering=-total_sales&type_exclude=store`
      if (this.member.role === 'Agent') {
        url += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.$axios.get(url)
        .then(response => {
          this.forms = response.data.results
          this.totalCount = response.data.count
          
          // if (this.totalCount % this.fetchCount == 0) {
          //   this.totalPage = this.totalCount/this.fetchCount
          // } else {
          //   this.totalPage = this.totalCount/this.fetchCount + 1
          // }
          // this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    getShareLinkURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.selectedFormSlug}/?customer=${this.lead.pid}`
    },
    clickShare () {
      window.open (`https://api.whatsapp.com/send?phone=${this.lead.phone}&text=${this.getShareLinkURL()}`)
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "select_form": "Select form"
  },
  "id": {
    "select_form": "Pilih form"
  }
}
</i18n>
